import React, { useState, useEffect } from "react";
import "./TreasurySummaryTab.scss";
import TreasuryChart from "../TreasuryChart/TreasuryChart";
import CurrencyHistoryTable from "../CurrencyHistoryTable/CurrencyHistoryTable";
import TransactionCustomerTable from "../TransactionCustomerTable/TransactionCustomerTable";
import { testingData } from "../../util/API/accounting";
import LoadingPage from "../UI/LoadingPage/LoadingPage";

function TreasurySummaryTab() {
  const [chartData, setChartData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currencyHistory, setCurrencyHistory] = useState();
  const [transferHistory, setTransferHistory] = useState();

  useEffect(() => {
    //get the data for the charts, it is a mock data that is returned
    const getChartData = async () => {
      const response = await testingData(4321);
      setChartData(response);

      let transferData = response.partnerTransfers.transferData;
      let currencyData = response.currencyHistory.currencyData;

      if (transferData.length != undefined) {
        setTransferHistory(transferData);
      } else {
        setTransferHistory([transferData]);
      }

      if (currencyData.length != undefined) {
        setCurrencyHistory(currencyData);
      } else {
        setCurrencyHistory([currencyData]);
      }

      setLoading(false);
    };

    getChartData();
  }, []);

  return (
    <div className="treasury-summary-container">
      {loading ? (
        <LoadingPage />
      ) : (
        <div>
          <div className="treasury-charts-container row">
            <div className=" col-xl-4 col-lg-12 col-md-12 col-sm-12 treasury-charts">
              <div className="treasury-chart-title">Liquidity Ratios</div>
              <div className="treasury-chart-box row">
                <div className="col-12 col-lg-4 chart-header">
                  {" "}
                  {/* Updated class to col-12 */}
                  Current Ratio
                  <div className="liquidity-chart">
                    {chartData.currentratio_now}
                  </div>
                </div>
                <div className="col-12 col-lg-4 chart-header">
                  {" "}
                  {/* Updated class to col-12 */}
                  Quick Ratio
                  <div className="liquidity-chart">
                    {chartData.quickratio_now}
                  </div>
                </div>
                <div className="col-12 col-lg-4 chart-header">
                  {" "}
                  {/* Updated class to col-12 */}
                  Operation Ratio
                  <div className="liquidity-chart">
                    {chartData.opsratio_now}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 treasury-charts">
              <div className="treasury-chart-title">Working Capital</div>
              <div className="treasury-chart-box row">
                <div className="col-12 col-lg-4 chart-header">
                  {" "}
                  {/* Updated class to col-12 */}
                  Order to Cash
                  <div className="d-flex justify-content-center">
                    <TreasuryChart
                      color={"#FAC800"}
                      centerText={chartData.data2label}
                      chartData={chartData.data2}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-4 chart-header">
                  {" "}
                  {/* Updated class to col-12 */}
                  Forecast to Fulfill
                  <div className="d-flex justify-content-center">
                    <TreasuryChart
                      color={"#5523D2"}
                      centerText={chartData.data3label}
                      chartData={chartData.data3}
                    />
                  </div>
                </div>
                <div className="col-12 col-lg-4 chart-header">
                  {" "}
                  {/* Updated class to col-12 */}
                  Cash Conversion
                  <div className="d-flex justify-content-center">
                    <TreasuryChart
                      color={"#3BC97B"}
                      centerText={chartData.data1label}
                      chartData={chartData.data1}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4 col-lg-12 col-md-12 col-sm-12 treasury-charts">
              <div className="treasury-chart-title">
                Contract Liquidity (30 Day Forecast)
              </div>
              <div className="treasury-chart-box row">
                <div className="col-12 col-lg-4 chart-header">
                  {" "}
                  {/* Updated class to col-12 */}
                  30 Day
                  <div className="liquidity-chart30">
                    {chartData.currentratio_30d}
                  </div>
                </div>
                <div className="col-12 col-lg-4 chart-header">
                  {" "}
                  {/* Updated class to col-12 */}
                  60 Day
                  <div className="liquidity-chart30">
                    {chartData.quickratio_30d}
                  </div>
                </div>
                <div className="col-12 col-lg-4 chart-header">
                  {" "}
                  {/* Updated class to col-12 */}
                  90 Day
                  <div className="liquidity-chart30">
                    {chartData.opsratio_30d}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="treasury-currency-container d-flex">
            <div className="currency-box">{chartData.currencyfx1}</div>
            <div className="currency-box">{chartData.currencyfx2}</div>
            <div className="currency-box">{chartData.currencyfx3}</div>
          </div>

          <>
            <div className="currency-history-table-container">
              <div className="treasury-chart-title">Currency History</div>
              <CurrencyHistoryTable currencyHistory={currencyHistory} />
            </div>
            <div className="currency-history-table-container">
              <div className="treasury-chart-title">Transfers</div>
              <TransactionCustomerTable transferHistory={transferHistory} />
            </div>
          </>
        </div>
      )}
    </div>
  );
}

export default TreasurySummaryTab;

{
  /* Filter Search */
}
{
  /* <div className="treasurying-filter-container">
        <div className="treasury-filtering-options">
          <label for="start-filter-treasury">Search Services:</label>
          <input
            type="text"
            id="start-filter-treasury"
            name="trip-start"
            //   onChange={handleStartDateChange}
            //   value={startDate}
          />
        </div>
        <div className="treasury-filtering-options">
          <label for="start-filter-treasury">Start date:</label>

          <input
            type="date"
            id="start-filter-treasury"
            name="trip-start"
            //   onChange={handleStartDateChange}
            //   value={startDate}
          />
        </div>
        <div className="treasury-filtering-options">
          <label for="end-filter-treasury">To</label>
          <input
            type="date"
            id="end-filter-treasury"
            name="trip-start"
            //   value={endDate}
            //   onChange={handleEndDateChange}
          />
        </div>
        <div className="filter-search">Search</div>
      </div> */
}
